import { render } from "./EDITCardP.vue?vue&type=template&id=07d44a6f&scoped=true"
import script from "./EDITCardP.vue?vue&type=script&lang=js"
export * from "./EDITCardP.vue?vue&type=script&lang=js"

import "./EDITCardP.vue?vue&type=style&index=0&id=07d44a6f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d44a6f"]])

export default __exports__